import { Component, Output, EventEmitter, Inject, Optional } from '@angular/core';
import { Globals } from '../../../globals';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialog } from '../../ConfirmationDialog';
import { QuickAddPartDialog } from '../../QuickAddPart/QuickAddPartDialog';
import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/API/auth.service';
import { BarcodeReaderComponent } from '../../Barcode/barcode-reader/barcode-reader.component';
import { CommonApiService } from 'src/app/API/commonapi.service.';
import { DMApiService } from 'src/app/API/dmapi.service';
import { InvApiService } from 'src/app/API/invapi.service';
import { BooleanCameraCapability } from 'html5-qrcode/esm/camera/core';
import { Router } from '@angular/router';

export interface PartsInventoryDialogData {
  equipementid: string;
  equipmentcode: string;
  equipmentDesc: string;
  divisionId: number;
  isDialogFromPartsComponent: boolean;
}

@Component({
  selector: 'PartsInventory',
  templateUrl: './PartsInventoryComponent.html',
  styleUrls: ['./PartsInventoryComponent.css']
})

export class PartsInventoryComponent {

  dialogRef: MatDialogRef<ConfirmationDialog>;
  quickBarcodeDialogRef: MatDialogRef<BarcodeReaderComponent>;
  currentDate = new Date();
  //public PrevParts = [];
  DivisionList = [];
  parterrormsg = '';
  noteparterrormsg = '';
  PartSearchTerm = '';
  //PartAutoComplete = 'test';
  PartSelectedItem = <any>{};
  public PartTrans = [];
 public currentUserId: number;
  //public currentUserName: string;
  PartQtyList = [];
  //SelectedPart;
  public partSearchResult = [];
  public partsDetails: InventoryCheckInPartsModel;
  //public componentDetails: InventoryCheckInPartsModel;
  //UserName = this.auth.GetUserName();
  //UserId = this.auth.GetUserId();
  today = new Date();
  //inventoryCheckInHistory= [];
  //hoveredLog: any = null;
  ///tooltipStyle = {};
  public PartList = [];
  partActionList = [
    { value: 'RECNEW', text: 'RECNEW' },
    { value: 'XFEROUT', text: 'XFEROUT' },
    { value: 'XFERIN', text: 'XFERIN' }
  ];

  selectedPartAction: string = 'RECNEW';
  selectedDivisionQty: 0;
  isRefNumberEnabled: boolean = true;
  isDialogFromPartsComponent: boolean = false;
  equipmentId: any;
  // @Output()
  // RaiseError = new EventEmitter();

  constructor(private router: Router,
    public dialog: MatDialog, public auth: AuthService, private commonapi : CommonApiService, public dmapi: DMApiService,
    private invapi: InvApiService,  @Optional() public dialogReftest?: MatDialogRef<PartsInventoryComponent>, 
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: PartsInventoryDialogData
  ) {
    //this.componentDetails = new InventoryCheckInPartsModel();
    this.partsDetails = new InventoryCheckInPartsModel();

    if(data != null)
    {
      this.PartSearchTerm = data.equipmentcode;
      this.equipmentId = data.equipementid;
      this.partsDetails.partDescription = data.equipmentDesc;
      this.partsDetails.divisionId = data.divisionId;
      this.isDialogFromPartsComponent = data.isDialogFromPartsComponent;
    }
  }

    ngOnInit() {
      this.selectedPartAction = 'RECNEW';
      this.fillDivisionList();
      this.auth.GetCurrentDateTimeFromServer().subscribe(today => {
        this.currentDate = new Date(today);

        while (this.PartQtyList.length <= 1000) {
          this.PartQtyList.push({
            text: (this.PartQtyList.length).toString(),
            value: (this.PartQtyList.length).toString()
          });
          }
          this.partsDetails.quantity =  0 ;
        }, error => {
      });

      this.invapi.GetPartsQunatityByPartID().subscribe(list => {  
        this.PartList = list
          .sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())
          .map(item => ({
            ...item,
            isDeleted: item.isDelete === true, // API → UI
            canDelete: false
          }));

        this.applyDeleteRule();

        if(this.isDialogFromPartsComponent)
        {
         this.PartList = this.PartList.filter(x => x.equipmentCode.toLowerCase().
                          includes(this.PartSearchTerm?.toLowerCase()));
        }
      });
    }

    fillDivisionList(defaultValue = '') {
      this.commonapi.FillDivision(false).subscribe(list => {
        this.DivisionList = list;

        if (!this.partsDetails.divisionId && this.DivisionList.length > 0) {
          this.partsDetails.divisionId = this.DivisionList[0].value;
        }
      });
    }

    openBarcodeScanner()
    {
      this.PartSearchTerm = '';
      this.quickBarcodeDialogRef = this.dialog.open(BarcodeReaderComponent, {
        disableClose: true,
        height: '90%',
        width: '90%',
      });
      this.quickBarcodeDialogRef.afterClosed().subscribe(result => {
      });

      this.quickBarcodeDialogRef.componentInstance.SaveEvent.subscribe(opt => {
        const serialNumber = { str: opt };
          this.invapi.GetEquipmentDetailsBySerialNumber(serialNumber).subscribe(
              success => {
                this.PartSelectedItem = success;
                if (success && success.equipmentType === 'PARTS') {
                  this.PartSelectedItem.equipementid = success.equipementId;
                  this.PartSearchTerm = success.equipmentCode;
                  this.partsDetails.partDescription = success.equipmentDesc;
                   this.selectedDivisionQty = success.quantity;
                  this.partsDetails.divisionId = success.divisionId;
                }
              },
              error => {
                if (error.error && error.error.returnMessage){
                  AppComponent.addAlert(error.error.returnMessage.toString(), 'error');
                  if( error.error.returnMessage.toString().includes('No equipment found for the given serial number.')) {
                    this.parterrormsg = 'No equipment found for the given serial number.';
                    return false;
                  }
                }
                else
                  AppComponent.addAlert(error.message, 'error');

                AppComponent.HideLoader();
              });
      });
    }

    PartCodeChange(type) {

      const dmPartCreate = <any>{};
      dmPartCreate.partsSearchtext = this.PartSearchTerm;
      this.partSearchResult = [];
      const obj = {
        itemCode: this.PartSearchTerm,
        desc: this.partsDetails.partDescription || '',
      };

        this.invapi.GetAllParts(obj).subscribe(
        success => {
          if (success) {
            this.partSearchResult = success;
           // console.log('Part Search Result', this.partSearchResult);
          }
        },
        error => {
        });
    }

    getPartCosts(option, type) {

      if (option && option.value) {
        if (type === 'code') {
          this.PartSelectedItem = this.partSearchResult.filter(
            x => x.equipmentcode === option.value
          )[0];
          this.partsDetails.partDescription = this.PartSelectedItem.equipmentDesc;
        } else {
          this.PartSelectedItem = this.partSearchResult.filter(
            x => x.equipmentDesc === option.value
          )[0];
          this.PartSearchTerm = this.PartSelectedItem.equipmentcode;
        }
        this.SetCost();
      }
    }

    SetCost() {
      //this.parterrormsg = '';
      if (this.partsDetails.quantity !==  0 && this.PartSelectedItem !== undefined && this.PartSelectedItem.itemcost
        && this.partsDetails.partDescription
      ) {
        this.partsDetails.totalCost = this.partsDetails.quantity * this.PartSelectedItem.itemcost;
      }

      if(this.partsDetails.quantity > this.selectedDivisionQty && this.selectedPartAction != 'RECNEW')
      {
        this.parterrormsg = 'You can not check out more than available quantity.';
        return;
      }
      else
      {
        this.parterrormsg = '';
      }
       
    }

    getDivisionName(divisionId) {
      return this.DivisionList.filter(x => x.value === divisionId)[0]?.text || '';
    }

    saveAndClose() {
    if (this.parterrormsg) {
      return false;
    }

  if (this.PartSearchTerm === '' || this.partsDetails.partDescription === '') {
    this.parterrormsg = 'Please select the part to Add.';
    return false;
  }

  if (!this.partsDetails.divisionId || this.partsDetails.divisionId === 0) {
    this.parterrormsg = 'Please select a valid division.';
    return false;
  }

  if (!this.partsDetails.quantity || this.partsDetails.quantity === 0) {
    this.parterrormsg = 'Quantity must be greater than zero to Add Part.';
    return false;
  }

  // Step 2: Validation of Selected Part
  if (!this.isDialogFromPartsComponent) {
    if (!this.PartSelectedItem || (!this.PartSelectedItem.equipementid && !this.PartSelectedItem.equipementId) || (this.PartSelectedItem.equipementid <= 0 && this.PartSelectedItem.equipementId <= 0)) {
      this.parterrormsg = 'Invalid Part selected.';
      return false;
    }
  }

  
  if (this.selectedPartAction === '' && this.partsDetails.refNumber !== '') {
    this.parterrormsg = 'Please add reference number.';
    return false;
  }
 

  if (this.isRefNumberEnabled) {
    const refErr = this.validateRefNumber(this.partsDetails.refNumber);
    if (refErr) {
      return false; // stop API call
    }
  }

  this.parterrormsg = '';

  let partID = this.PartSelectedItem?.equipementid ?? this.equipmentId;
 
  const now = new Date();
   const modelCreate: any = {
    PartQuantities: [
      {
        partID: partID,
        quantity: this.partsDetails.quantity,
        divisionID: this.partsDetails.divisionId,
        createdOn: Globals.GetAPIDate(now),
        createdBy: this.auth.GetUserId(),
        modifiedOn: Globals.GetAPIDate(now),
        modifiedBy: this.auth.GetUserId(),
        type: this.selectedPartAction,
        refNo: this.partsDetails.refNumber
      }
    ]
  };

  this.invapi.CreatePartsQuantityByDivisionId(modelCreate).subscribe({
    next: (success) => {
      AppComponent.loading = false;

      if (this.selectedPartAction === 'RECNEW') {
        AppComponent.addAlert('Part added successfully.', 'success');
      } else if (this.selectedPartAction === 'XFEROUT') {
        AppComponent.addAlert('Part check-out successfully.', 'success');
      } else if (this.selectedPartAction === 'XFERIN') {
        AppComponent.addAlert('Part check-in successfully.', 'success');
      }

        this.PartList = success
          .sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())
          .map(item => ({
            ...item,
            isDeleted: item.isDelete === true, // API → UI
            canDelete: false
          }));

        this.applyDeleteRule();

      if (this.isDialogFromPartsComponent) {
        this.PartList = this.PartList.filter(x =>
          x.equipmentCode.toLowerCase().includes(this.PartSearchTerm.toLowerCase())
        );

        const model = { partID: partID, divisionID: this.partsDetails.divisionId };
        this.invapi.GetPartsQuantityByDivisionID(model).subscribe({
         next: (qtySuccess: any) => {
            if (qtySuccess) {
              this.dialogReftest.close({
                partQuantity: qtySuccess.qty
              });
            }
          },
          error: () => {
            AppComponent.HideLoader();
          }
        });
      }

      // Step 5: Reset form
      this.resetPartForm();
    },
    error: (error) => {
      const errMsg = error?.error?.returnMessage || error.message || 'An error occurred.';
      AppComponent.addAlert(errMsg, 'error');
      AppComponent.HideLoader();
    }
  });
}

     applyDeleteRule() {
       const latestMap = new Map<string, any>();
        // reset flags
        this.PartList.forEach(item => {
          item.canDelete = false;
        });

        // find latest NON-DELETED per part+division
        for (const item of this.PartList) {
          const key = `${item.partID}_${item.divisionID}`;

          if (!item.isDeleted && !latestMap.has(key)) {
            latestMap.set(key, item);
            item.canDelete = true; // ONLY this row can be deleted
          }
        }
    }

    resetPartForm() {
      this.PartSearchTerm = '';
      this.partsDetails = new InventoryCheckInPartsModel();
      this.PartSelectedItem = <any>{};
      this.partSearchResult = [];
      this.noteparterrormsg = '';
      this.selectedPartAction = 'RECNEW';
      this.selectedDivisionQty = 0;
      this.isRefNumberEnabled = true;
    }

     onDivisionChange(event: any) {
        this.parterrormsg = '';
        AppComponent.ShowLoader();
        const model = { partID: this.PartSelectedItem.equipementid, divisionID: event.target.value };

        this.invapi.GetPartsQuantityByDivisionID(model).subscribe({
          next: (success: any) => {
            if (success && success.qty != null) {
              this.selectedDivisionQty = success.qty;
            } else {
              // ✅ if success is null or qty not present
              this.selectedDivisionQty = 0;
            }
            AppComponent.HideLoader();
          },
          error: () => {
            this.selectedDivisionQty = 0; // ✅ also safe fallback on error
            AppComponent.HideLoader();
          }
        });
    }

   onPartActionChange(event: any) {
    this.parterrormsg = '';
    const actionType = event.target.value;

    if(actionType === 'RECNEW')
    {
      this.isRefNumberEnabled = true;
    }

    if(actionType == 'XFEROUT')
    {
        if(this.isDialogFromPartsComponent && this.selectedDivisionQty == undefined)
        {
              const model = { partID: this.equipmentId, divisionID: this.partsDetails.divisionId};
              this.invapi.GetPartsQuantityByDivisionID(model).subscribe({
              next: (success: any) => {
                if (success) {
                  this.selectedDivisionQty =  success.qty;
                   const availableQty = this.selectedDivisionQty;
                  const newQty = this.partsDetails.quantity;
                  this.isRefNumberEnabled = false;
                  if(availableQty  && availableQty < newQty)
                  {
                    this.parterrormsg = 'You can not check out more than available quantity.';
                    return;
                  }

                  if(!availableQty)
                  {
                    this.parterrormsg = 'There are no part quantity available for selected division.';
                    return;
                  }
                }
                else
                {
                  this.parterrormsg = 'There is no available unassigned quantity.';
                  return;
                }
                AppComponent.HideLoader();
              },
              error: () => AppComponent.HideLoader()
            });
      }
      else
      {
          const availableQty = this.selectedDivisionQty;
          const newQty = this.partsDetails.quantity;
          this.isRefNumberEnabled = false;
          if(availableQty  && availableQty < newQty)
          {
            this.parterrormsg = 'You can not check out more than available quantity.';
            return;
          }

          if(!availableQty)
          {
            this.parterrormsg = 'There are no part quantity available for selected division.';
            return;
          }
      }
    }
    else if (actionType == 'XFERIN')
    {
       this.isRefNumberEnabled = false;
       let partID = this.PartSelectedItem.equipementid;
        if(partID == undefined)
        {
          partID = this.equipmentId;
        }

      const model = { partID: partID, divisionID: 0};
      this.invapi.GetPartsQuantityByDivisionID(model).subscribe({
      next: (success: any) => {
        if (success) {
          const unassignedQty =  success.qty;
          const selectedQty = this.partsDetails.quantity;

          if(unassignedQty != 0 && unassignedQty < selectedQty)
          {
            this.parterrormsg = 'You cannot check in more than the remaining' + '('+unassignedQty+')'+ +'unassigned quantity.'
            return;
          }
          if(unassignedQty == 0)
          {
            this.parterrormsg = 'There is no available unassigned quantity.';
            return;
          }
        }
        else
        {
          //when there is no unassigned quantity row entry
          this.parterrormsg = 'There is no available unassigned quantity.';
          return;
        }
        AppComponent.HideLoader();
      },
      error: () => AppComponent.HideLoader()
    });
    }
    else
    {
      this.parterrormsg = '';
    }
  }

      deletePartQuantity(item: any) {
        this.dialogRef = this.dialog.open(ConfirmationDialog, {
          disableClose: true
        });

        this.dialogRef.componentInstance.confirmMessage =
          'Are you sure you want to delete?';

        this.dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const model = { Id: item.partInOutID };

            this.invapi.DeletePartQuantity(model).subscribe({
              next: (success: any) => {
                if (success) {
                  item.isDeleted = true;   // mark deleted
                  item.canDelete = false; // remove delete button

                  // 🔥 VERY IMPORTANT
                  this.applyDeleteRule(); // recompute latest row
                }
                AppComponent.HideLoader();
              },
              error: () => AppComponent.HideLoader()
            });
          }
          this.dialogRef = null;
        });
}



  validateRefNumber(value: string): string {

    if (value === "" || value === undefined) {
      this.parterrormsg = 'Please enter a Ref No.';
      return "Please enter a Ref No.";
    }

    // Allow only alphanumeric
    if (!/^[a-zA-Z0-9]+$/.test(value)) {
      this.parterrormsg = 'Ref Number accepts alphanumeric characters only.';
      return this.parterrormsg;
    }

    // Block sequential numbers (e.g., 123456)
    if (/012345|123456|234567|345678|456789|567890/.test(value)) {
      this.parterrormsg = 'Ref Number cannot contain sequential digits.';
      return this.parterrormsg;
    }

    // Block repeated characters (aaaaa, 11111, etc.)
    if (/^(.)\1{4,}$/.test(value)) {
      this.parterrormsg = 'Ref Number cannot contain continuous repeated characters.';
      return this.parterrormsg;
    }

    // Block repeated digits (555555)
    if (/^(\d)\1{5,}$/.test(value)) {
      this.parterrormsg = 'Continuous repeated numbers are not allowed.';
      return this.parterrormsg;
    }

    this.parterrormsg = '';
    return '';  // No error
  }

  cancelDialog(): void {
    this.dialogReftest.close();
  }

  onEquipmentClick(item: any): void {
    const id = item.partID;
    this.router.navigate(['/Inventory/InventoryDetail'], {
        queryParams: { id, from: 'PartsInventory' }
    });
  }

}
export class InventoryCheckInPartsModel {
    Id:number;
    equipmentId:number;
    partName:string;
    partDescription:string;
    divisionId:number;
    quantity:number;
    totalCost:number;
    createdOn:Date;
    modifiedOn:Date;
    createdBy:string;
    modifiedBy:string;
    createdByName:string;
    showPartDelete:boolean;
    isAutoPart:boolean;
    refNumber:string;
     // UI-only flags
    isDelete?: boolean;    // delete button allowed
    isDeleted?: boolean;  // already deleted
    constructor(){
      this.quantity = 0;
      this.totalCost = 0;
      this.isAutoPart=false;
    }
}
